import { InputText } from 'primereact/inputtext'

import { Input } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { DEFAULT_EMAILS, FORMALITY_LEVELS } from '../constants'
import { CollapsibleSection } from './CollapsibleSection'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Sezione configurazione ambiente e identità utente per la debug console.
 * Gestisce environment, codSociety, tomcatCode, PID, email utente/operatore, formalità.
 * Layout 2 colonne per garantire visibilità completa dei valori.
 * @param {Object} props
 * @param {Object} props.config - Stato corrente della configurazione
 * @param {Function} props.setField - Funzione per aggiornare un campo
 * @param {Array} props.filteredEnvironments - Lista ambienti filtrati
 * @param {Array} props.travellersOptions - Lista PID disponibili
 */
export function EnvironmentSection({ config, setField, filteredEnvironments, travellersOptions }) {
  return (
    <CollapsibleSection
      id="environment"
      title={t.dbcEnvironment || 'Ambiente & Identità'}
      icon="pi pi-globe"
    >
      <div className="debug-params-grid nora-test-params">
        <div className="nfield" style={{ gridColumn: 'span 6' }}>
          <label>{t.selectEnvironment}</label>
          <Input
            id="selectedEnvironment"
            dropdown
            options={filteredEnvironments}
            value={config.selectedEnvironment}
            optionLabel="societyName"
            optionValue="codSociety"
            placeholder={t.selectEnvironmentPlaceholder}
            style={{ fontSize: 13, width: '100%', borderRadius: 8 }}
            onChange={({ selectedEnvironment }) =>
              setField('selectedEnvironment', selectedEnvironment)
            }
          />
        </div>

        <div className="nfield" style={{ gridColumn: 'span 6' }}>
          <label>{t.dbcCodSociety || 'Cod. Società'}</label>
          <InputText
            value={config.codSociety}
            onChange={(e) => setField('codSociety', e.target.value)}
            placeholder="es. RO, AA, 69"
          />
        </div>

        <div className="nfield" style={{ gridColumn: 'span 6' }}>
          <label>{t.dbcTomcatCode || 'Tomcat Code'}</label>
          <InputText
            value={config.tomcatCode}
            onChange={(e) => setField('tomcatCode', e.target.value)}
            placeholder="es. OUTS"
          />
        </div>

        <div className="nfield" style={{ gridColumn: 'span 6' }}>
          <label>{t.selectPID}</label>
          <Input
            id="selectedPID"
            dropdown
            options={travellersOptions}
            value={config.selectedPID}
            placeholder={t.selectPID}
            style={{ fontSize: 13, width: '100%', borderRadius: 8 }}
            onChange={({ selectedPID }) => setField('selectedPID', selectedPID)}
          />
        </div>

        <div className="nfield" style={{ gridColumn: 'span 6' }}>
          <label>{t.dbcUserEmail || 'Email Utente'}</label>
          <Input
            id="userEmail"
            dropdown
            options={DEFAULT_EMAILS}
            value={config.userEmail}
            editable
            placeholder={t.selectEmail}
            style={{ fontSize: 13, width: '100%', borderRadius: 8 }}
            onChange={({ userEmail }) => setField('userEmail', userEmail)}
          />
        </div>

        <div className="nfield" style={{ gridColumn: 'span 6' }}>
          <label>{t.dbcOperatorEmail || 'Email Operatore'}</label>
          <InputText
            value={config.operatorEmail}
            onChange={(e) => setField('operatorEmail', e.target.value)}
            placeholder="operator@siapcn.it"
          />
        </div>

        <div className="nfield" style={{ gridColumn: 'span 6' }}>
          <label>{t.indicateFormalityLevel}</label>
          <Input
            id="levelFormalita"
            dropdown
            options={FORMALITY_LEVELS}
            value={config.levelFormalita}
            placeholder={t.selectFormalityLevel}
            style={{ fontSize: 13, width: '100%', borderRadius: 8 }}
            onChange={({ levelFormalita }) => setField('levelFormalita', levelFormalita)}
          />
        </div>
      </div>
    </CollapsibleSection>
  )
}
